import type { Faq as FaqType } from '@ria-client/supergraph/base/types';
import { FaqSection } from '../Faq/faq-section';
import type { NodeProps } from '../types';

// Port of VE structured-content FAQ; props.faqs are the page faqs, set by populatePageFaqs.
export function FAQ({ props }: NodeProps<{ faqs?: FaqType[] }>) {
  return <FaqSection faqs={props.faqs} />;
}
